module.exports = __webpack_public_path__ + "img/maestro.44c9951e.svg";